import(/* webpackMode: "eager" */ "/workspace/src/app/error.tsx");
